import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

const subNavigationDefaultVars = {
  '--sub-navigation-item-color': m('--action-text-default-color'),
  '--sub-navigation-item-hover-color': m('--action-text-hover-color'),
  '--sub-navigation-item-active-color': m('--action-text-active-color'),
  '--sub-navigation-indicator-hover-color': m('--action-indicator-hover-color'),
  '--sub-navigation-indicator-active-color': m('--action-indicator-active-color'),
};

export const subNavigationBlackBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
};

export const subNavigationYellowBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
};

export const subNavigationGrayBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
};

export const subNavigationWhiteBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
};
